var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-button',{class:{ 'bg-indigo': _vm.isNew },attrs:{"variant":_vm.isNew ? 'success' : 'primary',"size":"sm"},on:{"click":_vm.onDeployButtonClicked}},[_vm._v("\n  "+_vm._s(_vm.isNew ? 'Activate' : 'Upgrade')+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }